import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09ce0828")

_pushScopeId("data-v-09ce0828")
const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "error-code" }, [
  /*#__PURE__*/_createTextVNode("4"),
  /*#__PURE__*/_createVNode("span", null, "0"),
  /*#__PURE__*/_createTextVNode("4")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "error-desc" }, [
  /*#__PURE__*/_createTextVNode(" 您所访问的页面好像还在"),
  /*#__PURE__*/_createVNode("span", { style: {"color":"#cc4300"} }, "飞机上"),
  /*#__PURE__*/_createTextVNode("，去其他页面看看吧。 ")
], -1)
const _hoisted_4 = { class: "error-handle" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 返回首页 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("返回上一页")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withId(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            onClick: _ctx.goHome
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "error-btn",
        size: "large",
        onClick: _ctx.goBack
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})